import { Provider } from 'react-redux';
import { BrowserRouter, Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory, History } from 'history';
import store from 'store';
import { ROOT } from 'configs/routeNames';
import Pages from './Pages';
import AboutUs from 'app/pages/AboutUs';
import Covid from 'app/pages/Covid';
import ContactUs from 'app/pages/ContactUs';
import ScrollToTop from 'utils/ScrollToTop';
import Loading from '../app/atoms/Loading';
import CityGuide from 'app/pages/CityGuide/CityGuide';
import LiveLikeALocal from '../app/pages/LondonWithDogs/LiveLikeALocal';
import NeighborhoodGuide from '../app/pages/NeighborhoodGuide/NeighborhoodGuide';
import Footer from '../app/molecules/Footer';
import HelpCenter from 'app/pages/HelpCenter/HelpCenter';
import TermsOfUse from '../app/pages/TermsOfUse/TermsOfUse';
import CookiePolicy from '../app/pages/CookiePolicy/CookiePolicy';
import PrivacyNotice from '../app/pages/PrivacyNotice/PrivacyNotice';
import ExplorersJournal from '../app/pages/ExplorersJournal/ExplorersJournal';
import Amplify from 'aws-amplify';
import { AWS_CONFIG } from '../aws-config/aws-config';
import UrbainHeader from 'app/molecules/UrbainHeader/UrbainHeader';
import InterhomeSuccessfulPayment from 'app/atoms/InterhomeSuccessfulPayment/InterhomeSuccessfulPayment';
import InterhomeRetryPayment from 'app/atoms/InterhomeRetryPayment/InterhomeRetryPayment';
import './Trackers.init';
import WithTracker from './WithTracker';
import AdditionalInformation from 'app/molecules/AdditionalInformation/AdditionalInformation';
import HolidayLikeALocal from 'app/pages/HolidayLikeALocal/HolidayLikeALocal';
import NewBeAnOwner from '../app/pages/NewBeAnOwner/NewBeAnOwner';

Amplify.configure(AWS_CONFIG);

const history: History = createBrowserHistory();

const App = () => {
  return (
    <Provider store={store}>
      <>
        <Loading />
        <Router history={history}>
          <BrowserRouter>
            <UrbainHeader fb linkedIn twitter />
            <ScrollToTop />
            <div style={{ minHeight: '90vh' }}>
              <Switch>
                {/*<Route path="/privacy" component={Privacy} />*/}
                <Route path="/contact-us" component={WithTracker(ContactUs)} />
                <Route path="/covid" component={WithTracker(Covid)} />
                <Route path="/about-us" component={WithTracker(AboutUs)} />
                <Route path="/city-guide/:city" component={WithTracker(CityGuide)} />
                <Route path="/live-like-a-local/:journal" component={WithTracker(LiveLikeALocal)} />
                <Route path="/holiday-like-a-local/:event" component={WithTracker(HolidayLikeALocal)} />
                <Route path="/help-center" component={WithTracker(HelpCenter)} />
                <Route path="/neighborhood-guide/:neighborhood" component={WithTracker(NeighborhoodGuide)} />
                <Route path="/explorers-journal" component={WithTracker(ExplorersJournal)} />
                <Route path="/terms-of-use" component={WithTracker(TermsOfUse)} />
                <Route path="/cookie-policy" component={WithTracker(CookiePolicy)} />
                <Route path="/privacy-notice" component={WithTracker(PrivacyNotice)} />
                <Route path="/list-your-home-urbain" component={WithTracker(NewBeAnOwner)} />
                <Route path="/additional-information" component={WithTracker(AdditionalInformation)} />
                <Route path="/interhome-successful-payment/:bookingReference" component={InterhomeSuccessfulPayment} />
                <Route path="/interhome-retry-payment" component={InterhomeRetryPayment} />
                <Route path={ROOT} component={Pages} />
              </Switch>
            </div>
            <Footer />
          </BrowserRouter>
          {/*<CookiePoliciesBanner />*/}
        </Router>
      </>
    </Provider>
  );
};

export default App;
